/**
 * Sticky Add to Cart Button for Mobile
 * Adds margin adjustment for Gladly Chat + SpiceGems Switcher widgets
 */
(function () {
  // Global theme config (used by Quick View + other PDP scripts)
  window.BauerThemeConfig = window.BauerThemeConfig || {};
  window.BauerThemeConfig.quickView = window.BauerThemeConfig.quickView || {};
  function bootStickyAddToCart() {
  function createStickyController({
    root,
    scrollContainer,
    attachTarget,
    footer,
    mobileOnly,
    enableWidgetsMargin,
    containerClassName,
    enableHysteresis = false
  }) {
    let originalButton = null;
    let productForm = null;
    let stickyContainer = null;
    let stickyButton = null;
    let lastButtonState = null;
    let hasAnimated = false;
    let intervalHandle = null;
    let observer = null;
    let ticking = false;
    let onProductLoaded = null;
    let hysteresisTimer = null;
    let widgetMarginRemovalTimer = null;

    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    const resolveRoot = () => root || document;
    const resolveScrollContainer = () => scrollContainer || window;
    const resolveAttachTarget = () => attachTarget || document.body;

    function getOriginalButton() {
      const r = resolveRoot();
      return r.querySelector('.product-form__submit:not(.sticky-mode)');
    }

    function getQuantitySection() {
      const r = resolveRoot();
      return r.querySelector('.product-form__quantity');
    }

    function isMobileEligible() {
      if (!mobileOnly) return true;
      return window.innerWidth < 768;
    }

    function observeOriginalButton() {
      const nextOriginalButton = getOriginalButton();
      if (!nextOriginalButton) return;

      if (observer) observer.disconnect();
      originalButton = nextOriginalButton;

      observer = new MutationObserver(mutations => {
        mutations.forEach(m => {
          if (['attributes', 'characterData', 'childList'].includes(m.type)) syncButtonStates();
        });
      });

      observer.observe(originalButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    
    function createStickyContainer() {
      if (stickyContainer) return;
      if (!originalButton) return;

      stickyContainer = document.createElement('div');
      stickyContainer.className = containerClassName || 'sticky-add-to-cart-container';
      stickyContainer.style.display = 'none';

      stickyButton = originalButton.cloneNode(true);
      stickyButton.classList.add('sticky-mode');
      stickyButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const btn = getOriginalButton();
        if (btn) btn.click();
      });

      stickyContainer.appendChild(stickyButton);
      resolveAttachTarget().appendChild(stickyContainer);
    }

    function syncButtonStates() {
      if (!stickyButton) return;
      originalButton = getOriginalButton();
      if (!originalButton) return;
      stickyButton.toggleAttribute('disabled', originalButton.hasAttribute('disabled'));
      stickyButton.setAttribute('aria-disabled', originalButton.getAttribute('aria-disabled') || 'false');
      stickyButton.classList.toggle('loading', originalButton.classList.contains('loading'));
      stickyButton.textContent = originalButton.textContent;
    }
    

    function getViewportHeight() {
      if (typeof window.visualViewport !== 'undefined' && window.visualViewport.height > 0) {
        return window.visualViewport.height;
      }
      return window.innerHeight;
    }

    function isBottomVisible() {
      const sc = resolveScrollContainer();
      if (sc === window) {
        const scrollY = window.scrollY;
        const windowHeight = getViewportHeight();
        const documentHeight = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight || 0
        );
        if (footer) {
          const footerRect = footer.getBoundingClientRect();
          const footerTop = footerRect.top + scrollY;
          return scrollY + windowHeight >= footerTop - 50;
        }
        return scrollY + windowHeight >= documentHeight - 100;
      }

      return sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 50;
    }

    function isQuantityVisible() {
      const quantitySection = getQuantitySection();
      if (!quantitySection) return false;

      const rect = quantitySection.getBoundingClientRect();
      const sc = resolveScrollContainer();

      if (sc === window) {
        const vh = getViewportHeight();
        return rect.top >= 0 && rect.bottom <= vh;
      }

      const containerRect = sc.getBoundingClientRect();
      return rect.top >= containerRect.top && rect.bottom <= containerRect.bottom;
    }

    function applyWidgetMargin(element, addMargin) {
      if (addMargin) {
        element.classList.add('spicegems_switcher-fixed-position');
        element.style.marginBottom = '7rem';
        element.style.setProperty('margin-bottom', '7rem', 'important');
      } else {
        element.style.removeProperty('margin-bottom');
      }
    }

    function updateWidgetsMargin(addMargin) {
      if (!enableWidgetsMargin) return;

      if (intervalHandle) {
        clearInterval(intervalHandle);
        intervalHandle = null;
      }

      const updateAll = () => {
        const gladlyChat = document.getElementById('gladlyChat_container');
        const spicegemsSwitcher = document.querySelector('.spicegems_switcher-fixed-position');

        if (gladlyChat) applyWidgetMargin(gladlyChat, addMargin);
        if (spicegemsSwitcher) applyWidgetMargin(spicegemsSwitcher, addMargin);
      };

      updateAll();

      if (addMargin) {
        const startTime = Date.now();
        intervalHandle = setInterval(() => {
          const elapsed = Date.now() - startTime;
          if (elapsed >= 10000) {
            clearInterval(intervalHandle);
            intervalHandle = null;
            return;
          }
          updateAll();
        }, 100);
      }
    }

    function hideStickyAndReset() {
      cancelMarginRemoval();
      if (stickyContainer) stickyContainer.style.display = 'none';
      if (originalButton) originalButton.style.visibility = '';
      updateWidgetsMargin(false);
      lastButtonState = null;
      hasAnimated = false;
    }

    function toggleStickyButton() {
      productForm = resolveRoot().querySelector('.product-form');
      originalButton = getOriginalButton();

      if (!originalButton || !productForm) {
        if (hysteresisTimer) clearTimeout(hysteresisTimer);
        hysteresisTimer = null;
        hideStickyAndReset();
        return;
      }

      if (!isMobileEligible()) {
        if (hysteresisTimer) clearTimeout(hysteresisTimer);
        hysteresisTimer = null;
        hideStickyAndReset();
        return;
      }

      const quantityVisible = isQuantityVisible();
      const bottomVisible = isBottomVisible();
      let currentState = quantityVisible ? 'normal' : bottomVisible ? 'hidden' : 'sticky';

      if (enableHysteresis && lastButtonState === 'sticky' && currentState === 'normal') {
        if (!hysteresisTimer) {
          hysteresisTimer = setTimeout(() => {
            hysteresisTimer = null;
            if (isQuantityVisible()) {
              currentState = 'normal';
              applyStateChange(currentState);
            }
          }, 200);
        }
        return;
      }
      if (hysteresisTimer) {
        clearTimeout(hysteresisTimer);
        hysteresisTimer = null;
      }

      if (currentState !== lastButtonState) {
        applyStateChange(currentState);
      } else if (currentState === 'sticky') {
        syncButtonStates();
      }
    }

    function scheduleMarginRemoval() {
      if (widgetMarginRemovalTimer) clearTimeout(widgetMarginRemovalTimer);
      if (isIOS && enableWidgetsMargin) {
        widgetMarginRemovalTimer = setTimeout(() => {
          widgetMarginRemovalTimer = null;
          updateWidgetsMargin(false);
        }, 150);
      } else {
        updateWidgetsMargin(false);
      }
    }

    function cancelMarginRemoval() {
      if (widgetMarginRemovalTimer) {
        clearTimeout(widgetMarginRemovalTimer);
        widgetMarginRemovalTimer = null;
      }
    }

    function applyStateChange(currentState) {
        createStickyContainer();

        switch (currentState) {
          case 'normal':
            originalButton.style.visibility = '';
            stickyContainer.style.display = 'none';
            hasAnimated = false;
            scheduleMarginRemoval();
            break;
          case 'hidden':
            originalButton.style.visibility = 'hidden';
            stickyContainer.style.display = 'none';
            scheduleMarginRemoval();
            break;
          case 'sticky':
            cancelMarginRemoval();
            originalButton.style.visibility = 'hidden';
            if (!hasAnimated) {
              stickyContainer.style.animation = 'none';
              stickyContainer.style.display = 'block';
              void stickyContainer.offsetWidth;
              stickyContainer.style.animation = '';
              hasAnimated = true;
            } else {
              stickyContainer.style.display = 'block';
            }
            syncButtonStates();
            updateWidgetsMargin(true);
            break;
        }

        lastButtonState = currentState;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          toggleStickyButton();
          ticking = false;
        });
        ticking = true;
      }
    }

    function start() {
      productForm = resolveRoot().querySelector('.product-form');
      if (!productForm || !getOriginalButton()) return false;

      observeOriginalButton();
      const sc = resolveScrollContainer();

      if (sc === window) {
        window.addEventListener('scroll', onScroll);
        if (isIOS && typeof window.visualViewport !== 'undefined') {
          window.visualViewport.addEventListener('resize', onScroll);
          window.visualViewport.addEventListener('scroll', onScroll);
        }
      } else {
        sc.addEventListener('scroll', onScroll, { passive: true });
      }

      window.addEventListener('resize', toggleStickyButton);

      onProductLoaded = () => {
        observeOriginalButton();
        syncButtonStates();
        toggleStickyButton();
      };
      document.addEventListener('product:loaded', onProductLoaded);

      toggleStickyButton();
      return true;
    }

    function destroy() {
      if (hysteresisTimer) {
        clearTimeout(hysteresisTimer);
        hysteresisTimer = null;
      }
      cancelMarginRemoval();
      if (originalButton) originalButton.style.visibility = '';

      const sc = resolveScrollContainer();
      if (sc === window) {
        window.removeEventListener('scroll', onScroll);
        if (isIOS && typeof window.visualViewport !== 'undefined') {
          window.visualViewport.removeEventListener('resize', onScroll);
          window.visualViewport.removeEventListener('scroll', onScroll);
        }
      } else {
        sc.removeEventListener('scroll', onScroll);
      }

      window.removeEventListener('resize', toggleStickyButton);

      // This listener is cheap, but controllers are re-created in quick view.
      // Remove it to avoid stacking handlers over time.
      if (typeof onProductLoaded === 'function') {
        document.removeEventListener('product:loaded', onProductLoaded);
      }
      onProductLoaded = null;

      if (observer) observer.disconnect();
      if (intervalHandle) clearInterval(intervalHandle);
      intervalHandle = null;

      updateWidgetsMargin(false);

      if (stickyContainer && stickyContainer.parentNode) stickyContainer.parentNode.removeChild(stickyContainer);
      stickyContainer = null;
      stickyButton = null;
      originalButton = null;
      productForm = null;
      lastButtonState = null;
    }

    return { start, destroy, toggle: toggleStickyButton };
  }

  // -------------------------------
  // PDP: Mobile only
  // -------------------------------
  const footer =
    document.querySelector('footer.footer, .footer, footer, #footer') ||
    document.querySelector('[class*="footer"]');

  const pdpRoot = Array.from(
    document.querySelectorAll('.shopify-section.product-section.spaced-section, .shopify-section.product-section')
  ).find((section) => !section.closest('#quickViewDrawer'));

  if (pdpRoot) {
    const pdpController = createStickyController({
      root: pdpRoot,
      scrollContainer: window,
      attachTarget: document.body,
      footer,
      mobileOnly: true,
      enableWidgetsMargin: true,
      containerClassName: 'sticky-add-to-cart-container'
    });
    pdpController.start();
  }

  // -------------------------------
  // Quick view: Desktop + Mobile
  // -------------------------------
  const quickViewDrawer = document.getElementById('quickViewDrawer');
  const quickViewDrawerContent = document.getElementById('drawerContent');
  const quickViewAltContainer = document.getElementById('altContainer');

  if (quickViewDrawer && quickViewDrawerContent && quickViewAltContainer) {
    let quickViewController = null;
    let quickViewStickyDebounceTimer = null;

    const isQuickViewOpen = () =>
      quickViewDrawer.classList.contains('show') && !quickViewDrawer.classList.contains('hidden');

    const initOrRefreshQuickViewSticky = () => {
      if (!isQuickViewOpen()) {
        if (quickViewController) {
          quickViewController.destroy();
          quickViewController = null;
        }
        return;
      }

      const scopedRoot =
        quickViewAltContainer.querySelector('.shopify-section.product-section') || quickViewAltContainer;
      const hasForm = scopedRoot.querySelector('.product-form');
      const hasButton = scopedRoot.querySelector('.product-form__submit');
      if (!hasForm || !hasButton) return;

      if (quickViewController) quickViewController.destroy();

      quickViewController = createStickyController({
        root: scopedRoot,
        scrollContainer: quickViewDrawerContent,
        attachTarget: quickViewDrawerContent,
        footer: null,
        mobileOnly: false,
        enableWidgetsMargin: false,
        containerClassName: 'sticky-add-to-cart-container sticky-add-to-cart-container--quick-view',
        enableHysteresis: true
      });
      quickViewController.start();
    };

    const debouncedInitQuickViewSticky = () => {
      clearTimeout(quickViewStickyDebounceTimer);
      quickViewStickyDebounceTimer = setTimeout(initOrRefreshQuickViewSticky, 350);
    };
    const isMutationInMediaOnly = (mutations) => {
      return mutations.length > 0 && mutations.every((m) => {
        const el = m.target?.nodeType === 1 ? m.target : m.target?.parentElement;
        return el?.closest?.('.product__media-wrapper, media-gallery, [id^="MediaGallery"]');
      });
    };
    const altObserver = new MutationObserver((mutations) => {
      if (isMutationInMediaOnly(mutations)) return;
      debouncedInitQuickViewSticky();
    });
    altObserver.observe(quickViewAltContainer, { childList: true, subtree: true });

    const drawerObserver = new MutationObserver(() => {
      clearTimeout(quickViewStickyDebounceTimer);
      initOrRefreshQuickViewSticky();
    });
    drawerObserver.observe(quickViewDrawer, { attributes: true, attributeFilter: ['class'] });

    initOrRefreshQuickViewSticky();
  }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootStickyAddToCart);
  } else {
    bootStickyAddToCart();
  }
})();
